import { render, staticRenderFns } from "./ProductPhotosDownload.vue?vue&type=template&id=42029470"
import script from "./ProductPhotosDownload.ts?vue&type=script&lang=ts&external"
export * from "./ProductPhotosDownload.ts?vue&type=script&lang=ts&external"
import style0 from "./ProductPhotosDownload.vue?vue&type=style&index=0&id=42029470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
